import { ButtonLink } from '@app/components/base/ButtonLink';
import { RudoPlatform } from '@app/modules/social-export/domain/platforms';
import { connectionsManageMessages } from '@app/modules/social-export/screens/manage/connections-manage-messages';
import { useIntl } from 'react-intl';

/**
 * Connect CTA that routes to the Rudo access-token form (no OAuth).
 */
export function RudoConnect() {
  const { $t } = useIntl();

  return (
    <ButtonLink
      to="/admin/social-export/rudo/connect"
      variant="outlined"
      color="primary"
      size="small"
      startIcon={RudoPlatform.Icon()}
    >
      {$t(connectionsManageMessages.connect)}
    </ButtonLink>
  );
}
